<template>
    <div class="dx_product-image__container">
        <splide class="dx_product-image__main" :slides="productMedia" :options="primaryOptions" ref="primary">
            <splide-slide class="dx_product-image__main-image" v-for="media in productMedia" :key="media.big">
                <picture v-if="media.is_image">
                    <source media="(max-width: 319px)" type="image/webp"
                            :srcset="media.small_webp">
                    <source media="(min-width: 320px)" type="image/webp"
                            :srcset="media.big_webp">
                    <img :src="media.big"
                         :alt="product.name"
                         :title="product.name"
                    />
                </picture>
                <iframe width="560" height="315" v-if="media.is_youtube" class="youtubeEmbed dx_youtube"
                        :src="media.youtube_embed" :title="media.title" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen>
                </iframe>
            </splide-slide>
        </splide>
        <splide v-if="productMedia.length > 1" class="dx_product-image__thumbnails" :slides="productMedia"
                :options="secondaryOptions" ref="secondary">
            <splide-slide class="dx_product-image__secondary-image" v-for="media in productMedia" :key="media.big">
                <picture v-if="media.is_image">
                    <source media="(max-width: 319px)" type="image/webp"
                            :srcset="media.small">
                    <source media="(min-width: 320px)" type="image/webp"
                            :srcset="media.big">
                    <img :src="media.big"
                         :alt="product.name"
                         :title="product.name"
                    />
                </picture>
                <span v-html="icons['video-placeholder']" v-if="media.is_youtube" :title="media.title"></span>
            </splide-slide>
        </splide>

        <div class="product-image-footer">
            <em>{{ product.warning_shipped_in_different_variants }}</em>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MainMedia',
    data: function () {
        return {
            primaryOptions: {
                type: 'slide',
                heightRatio: 1,
                pagination: false,
                arrows: true,
                cover: true,
                arrowPath: 'M24.5115 34.5117C24.1972 34.8153 23.7762 34.9833 23.3392 34.9795C22.9022 34.9757 22.4842 34.8004 22.1751 34.4914C21.8661 34.1824 21.6908 33.7644 21.687 33.3274C21.6832 32.8904 21.8512 32.4694 22.1548 32.155L32.6432 21.6667H3.33317C2.89114 21.6667 2.46722 21.4911 2.15466 21.1785C1.8421 20.866 1.6665 20.4421 1.6665 20C1.6665 19.558 1.8421 19.1341 2.15466 18.8215C2.46722 18.509 2.89114 18.3334 3.33317 18.3334H32.6432L22.1548 7.84503C21.8512 7.53069 21.6832 7.10969 21.687 6.67269C21.6908 6.2357 21.8661 5.81768 22.1751 5.50866C22.4842 5.19965 22.9022 5.02437 23.3392 5.02057C23.7762 5.01677 24.1972 5.18476 24.5115 5.48836L37.8448 18.8217C37.9992 18.9769 38.1216 19.1609 38.2048 19.3634C38.2895 19.5649 38.3332 19.7814 38.3332 20C38.3332 20.2187 38.2895 20.4351 38.2048 20.6367C38.1216 20.8391 37.9992 21.0232 37.8448 21.1784L24.5115 34.5117Z',
            },
            secondaryOptions: {
                fixedWidth: 100,
                fixedHeight: 100,
                isNavigation: true,
                autoWidth: true,
                gap: 10,
                pagination: false,
                focus: 'center',
                cover: true,
                arrows: false,
                breakpoints: {
                    '568': {
                        fixedWidth: 66,
                        fixedHeight: 66,
                        focus: 'center',
                    }
                }
            }
        }
    },
    updated() {
        if (this.$refs.secondary) {
            this.$refs.primary.sync(this.$refs.secondary.splide);
        }
    },
    mounted() {
        if (this.$refs.secondary) {
            this.$refs.primary.sync(this.$refs.secondary.splide);
        }
    },
    computed: {
        productMedia() {
            return this.$store.getters.productMedia;
        },
        product() {
            return this.$store.getters.activeProduct
        },
        icons() {
            return this.$store.getters.icons;
        }
    }
}
</script>
